export const ACCEPTABLE_HEADERS = {
  Grower: [
    'grower', 'vendor name', 'nme1', 'grower name'
  ],
  'Contract Number': [
    'contract #', 'grower contract', 'contract i#d#', 'speclnst1', 'contract id', 'specialist1', 'specInst1'
  ],
  Date: [
    'date', 'irticketdate', 'tickdate', 'ticket date'
  ],
  'Ticket Number': [
    'irticketnumber', 'ticketno', 'ticket', 'ticket number', 'ticket #', 'tickno'
  ],
  BOL: [
    'speclnst2-bol', 'speclnst2', 'irbilloflanding', 'bol', 'bol number', 'bol#', 'bill of landing', 'irbilloflading', 'specinst2-bol', 'specinst2'
  ],
  'Gross Weight': [
    'grosslbs', 'irgrossweight', 'gross', 'gross weight', 'gross lbs'
  ],
  Tare: [
    'tare', 'tare weight', 'tarelbs', 'irtareweight'
  ],
  'Net Weight': [
    'irnetweight', 'netlbs', 'netweight', 'netwgt', 'net weight'
  ],
  'Gross Qty': [
    'gross_qty', 'grossqty', 'gross qty', 'irgrossqty', 'irgrossquantity', 'gross quantity'
  ],
  'Net Qty': [
    'irnetqty', 'net qty', 'net qty', 'net_qty', 'net quantity', 'netqty'
  ],
  'Test Weight': [
    'tw', 'tw-gf', 't#w#', 'weight', 'test weight', 't.w.'
  ],
  MST: [
    'mst', 'moist#', 'mst#', 'moist-gf', 'moist', 'moisture', 'moist.', 'mo'
  ],
  FM: [
    'fm', 'f#m#', 'fm-gf', 'foreign material', 'f.m.'
  ],
  DMG: [
    'dm', 'dam', 'dam#', 'dmg#', 'damage', 'damage-gf', 'dmg#', 'dmg', 'dam.'
  ],
  RVA: [
    'pass/fail', 'rva', '1 pass / 2 fail'
  ]
}

// export const REQUIRED_HEADERS = [
//   'BOL', 'Date', 'Grower', 'Ticket Number', 'Net Qty', 'FM', 'Gross Qty', 'MST', 'DMG', 'Test Weight','RVA'
// ]

export const REQUIRED_HEADERS = [
  'Date', 'Grower', 'Net Qty'
]

export const TRAINING_ACCEPTABLE_HEADERS = {
  'Company SAP ID': [
    'Company SAP ID', 'SAP ID', 'Company ID', 'SAP_ID'
  ],
  'Contract Name': [
    'Contract Name', 'Name'
  ],
  'Company Name': [
    'Company Name', 'Company_Name', 'CompanyName'
  ],
  'Contact Email': [
    'Contact Email', 'email', 'Eamil'
  ]
}

export const TRAINING_REQUIRED_HEADERS = [
  'Company SAP ID'
]